var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "600px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("h4", [
        _vm._v(_vm._s(this.$t("BusinessPurchaseApplyDetail.reviewResult"))),
      ]),
      _c(
        "el-radio-group",
        {
          attrs: { disabled: _vm.form.disabled },
          model: {
            value: _vm.form.auditResult,
            callback: function ($$v) {
              _vm.$set(_vm.form, "auditResult", $$v)
            },
            expression: "form.auditResult",
          },
        },
        [
          _c("el-radio", { attrs: { label: "1" } }, [
            _vm._v(
              _vm._s(this.$t("BusinessPurchaseApplyDetail.reviewResult2"))
            ),
          ]),
          _c("el-radio", { attrs: { label: "2" } }, [
            _vm._v(
              _vm._s(this.$t("BusinessPurchaseApplyDetail.reviewResult1"))
            ),
          ]),
        ],
        1
      ),
      _c("h4", [
        _vm._v(_vm._s(this.$t("BusinessPurchaseApplyDetail.reviewRemark"))),
      ]),
      _c(
        "div",
        { staticClass: "relative" },
        [
          _c("BjUpload", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false",
              },
            ],
            ref: "BjUpload",
            staticClass: "avatar-uploader",
            attrs: { "auto-upload": "" },
            on: { afterUpload: _vm.afterUpload },
          }),
          _c("quill-editor", {
            ref: "myQuillEditor",
            staticClass: "quillHeight",
            attrs: {
              disabled: _vm.form.disabled,
              options: _vm.editorOption,
              placeholder: _vm.$t("BusinessPurchaseApplyDetail.wordLimitText"),
            },
            on: {
              change: function ($event) {
                return _vm.onEditorChange($event)
              },
            },
            model: {
              value: _vm.form.remark,
              callback: function ($$v) {
                _vm.$set(_vm.form, "remark", $$v)
              },
              expression: "form.remark",
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }